import { z } from "zod";

export const resetPasswordSchema = z
  .object({
    password: z.string().min(1, "Password is required"),
    confirmPassword: z.string().min(1, "Please confirm your password"),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: "Password do not match",
    path: ["confirmPassword"],
  });

export type ResetPasswordFormData = z.infer<typeof resetPasswordSchema>;

export const defaultValues: ResetPasswordFormData = {
  password: "",
  confirmPassword: "",
};

export const PAGE_CONFIG = {
  TITLE: "Reset Password",
} as const;
